import React from "react";
import { Box, CircularProgress, Typography, alpha } from "@mui/material";

export interface IStatistic {
  icon: React.ReactNode;
  value: string | number;
  label: string;
  isLoading?: boolean;
  hasError?: boolean;
}

type ExtendedHomeStatisticsCardProps = IStatistic;

export const ExtendedHomeStatisticsCard: React.FC<
  ExtendedHomeStatisticsCardProps
> = ({ icon, value, label, isLoading, hasError }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 1.5,
        minWidth: 0,
        padding: 2,
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: "15px",
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: 0.5, minWidth: 0 }}
      >
        {isLoading ? (
          <Box sx={{ display: "flex", alignItems: "center", height: 40 }}>
            <CircularProgress
              size={24}
              sx={(theme) => ({ color: theme.palette.custom.brandTeal })}
            />
          </Box>
        ) : hasError ? (
          <Typography
            variant="h3"
            noWrap
            sx={{ color: "text.secondary" }}
            title="Failed to load"
          >
            —
          </Typography>
        ) : (
          <Typography variant="h3" noWrap sx={{ color: "text.primary" }}>
            {value}
          </Typography>
        )}
        <Typography variant="body2" noWrap sx={{ color: "text.secondary" }}>
          {label}
        </Typography>
      </Box>
      
      <Box
        sx={(theme) => ({
          display: "flex",
          flexShrink: 0,
          width: 36,
          height: 36,
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          bgcolor: alpha(theme.palette.custom.brandTeal, 0.1),
          color: theme.palette.custom.brandTeal,
        })}
      >
        {icon}
      </Box>
    </Box>
  );
};

export default ExtendedHomeStatisticsCard;
